module.exports = __webpack_public_path__ + "img/huace11.09112142.jpg";